import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import { TOOLBAR_REPORT_MAP } from '@src/framework/workbench/middleware/report';
import { IRightSideBarManager } from '@src/slide/application/service/right-side-bar-manager/right-side-bar-manager.interface';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { Feature, ToolbarService } from '@tencent/workbench';
import { observable, reaction } from 'mobx';
import * as React from 'react';
import { CheckboxWithLabel } from '../../common/components/checkbox-component';
import { IAnimCornerMarkFeature } from './anim-corner-mark-interface';
import { config } from './config';

@Feature()
export class AnimCornerMarkFeature extends BaseToolbarFeature implements IAnimCornerMarkFeature {
    public id = config.id;
    public config = config;
    @observable
    public shouldHideAllBadges = false;
    @observable
    private rightSideBarManager = this.getRightSideBarManager();

    public constructor(protected readonly toolbarService: ToolbarService) {
        super();
        // 监听由其他入口触发的变更
        reaction(
            () => this.shouldHideAllBadges,
            () => {
                this.toolbarService.$forceUpdate();
            },
        );
    }

    public handleSwitch(): void {
        this.shouldHideAllBadges = !this.shouldHideAllBadges;
    }

    public getContent = () => (
        <CheckboxWithLabel
            label={this.config.content}
            checked={this.shouldHideAllBadges}
            onChange={() => {
                // this.toggleDisplay();
                this.report();
            }}
        />
    );

    /**
     * 根据动画窗格的开关控制隐藏角标按钮是否禁用ui的渲染
     * 开（不禁用）
     * 关（禁用）
     */
    public shouldDisabled(): boolean {
        // 开窗格不禁用
        if (this.rightSideBarManager?.isAnimationEditorShown) {
            return false;
        }
        // 关窗格禁用
        return true;
    }

    private getRightSideBarManager(): IRightSideBarManager | undefined {
        return this.getAppService().editableServiceLayer?.rightSideBarManager;
    }

    /**
     * 上报数据
     */
    private report() {
        tdw({
            ...TOOLBAR_REPORT_MAP[this.config.id](),
            ver5: this.shouldHideAllBadges ? 1 : 0,
        });
    }
}
